import { createSelector } from "reselect";
import { RootState } from "../../../../../store/rootReducer";
import { selectSearchPeople } from "src/types/form";

const searchPeople = (state: RootState) => state.searchUsers.users;

export const searchPeopleSelector = createSelector([searchPeople], (users) => {
  let retArr: selectSearchPeople[] = [];
  users.map((user: any) => {
    let email =
      user.AccountName.split("|")[user.AccountName.split("|").length - 1];
    let displayName = user.PreferredName;
    if (displayName.split(" ").length === 3) {
      displayName = `${displayName.split(" ")[0]} ${displayName.split(" ")[1]}`;
    }
    retArr = [
      ...retArr,
      {
        value: email.toLowerCase().trim(),
        label: `${displayName}${
          (user.apiGlobalID && " (" + user.apiGlobalID + ")") ||
          (user.UserName && " (" + user.UserName + ")") ||
          " (Нет номера)"
        }`,
        avatar: user.PictureUrl,
        id: user.id,
      },
    ];
  });
  return retArr;
});
